import { makeStyles } from '@material-ui/core'

const COLUMNS = 'minmax(0, 1fr) 6rem 5.5rem 7rem'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 .9rem',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      padding: 0,
    },
  },
  paper: {
    display: 'flex',
    width: '100%',
    maxWidth: '820px',
    maxHeight: '85vh',
    flexDirection: 'column',
    padding: '1.5rem',
    borderRadius: '16px',
    outline: 'none',
    color: '#1D2939',
    background: '#FFFFFF',
    boxShadow: '0 24px 48px rgba(16, 24, 40, .24)',
    fontFamily: '"Inter", sans-serif',
    [theme.breakpoints.down('xs')]: {
      height: '100vh',
      maxWidth: 'none',
      maxHeight: 'none',
      padding: 0,
      borderRadius: 0,
      background: '#F5F6F3',
      boxShadow: 'none',
    },
  },
  desktopOnly: {
    [theme.breakpoints.down('xs')]: {
      display: 'none !important',
    },
  },
  mobileOnly: {
    display: 'none !important',
    [theme.breakpoints.down('xs')]: {
      display: 'inline-flex !important',
    },
  },

  header: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '1rem',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
      gap: '.75rem',
      padding: '1rem',
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
    },
  },
  headerText: {
    display: 'flex',
    minWidth: 0,
    flex: '1 1 auto',
    flexDirection: 'column',
  },
  title: {
    fontFamily: 'inherit',
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.125rem',
    },
  },
  subtitle: {
    order: 1,
    marginTop: '.15rem',
    color: '#667085',
    fontFamily: 'inherit',
    fontSize: '.8125rem',
    [theme.breakpoints.down('xs')]: {
      order: 0,
      marginTop: 0,
      fontSize: '.75rem',
      fontWeight: 600,
    },
  },
  closeButton: {
    display: 'inline-flex',
    width: '2.25rem',
    height: '2.25rem',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    borderRadius: '50%',
    background: '#F2F4F7',
    '&:hover': {
      backgroundColor: '#EAECF0',
    },
  },
  backButton: {
    width: '2rem',
    height: '2rem',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    borderRadius: '50%',
    background: '#F2F4F7',
    '&:hover': {
      backgroundColor: '#EAECF0',
    },
  },
  headerIcon: {
    fontSize: '1.25rem',
    color: '#475467',
  },

  tabsWrapper: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    marginTop: '1.25rem',
    borderBottom: '1px solid #EAECF0',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
      gap: 0,
      marginTop: 0,
      padding: '.75rem 1rem .25rem',
      border: 0,
    },
  },
  tabs: {
    display: 'flex',
    order: 0,
    gap: '1.5rem',
    [theme.breakpoints.down('xs')]: {
      order: 1,
      gap: '1rem',
      marginTop: '.625rem',
      borderBottom: '1px solid #EAECF0',
    },
  },
  tab: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '.4rem',
    marginBottom: '-1px',
    padding: '.5rem 0',
    borderBottom: '2px solid transparent',
    borderRadius: 0,
    color: '#667085',
    fontFamily: 'inherit',
    fontSize: '.875rem',
    fontWeight: 700,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('xs')]: {
      gap: '.3rem',
      padding: '.4rem 0',
      fontSize: '.8125rem',
    },
  },
  tabActive: {
    color: '#1D2939',
    borderBottomColor: '#416D0B',
  },
  tabCount: {
    display: 'inline-flex',
    minWidth: '1.25rem',
    height: '1.25rem',
    padding: '0 .3rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '999px',
    color: '#475467',
    background: '#F2F4F7',
    fontSize: '.75rem',
    lineHeight: 1,
    [theme.breakpoints.down('xs')]: {
      minWidth: 0,
      height: 'auto',
      padding: 0,
      color: '#667085',
      background: 'transparent',
      fontSize: 'inherit',
      lineHeight: 'inherit',
    },
  },

  attentionFilter: {
    display: 'inline-flex',
    order: 1,
    height: '2rem',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '.35rem',
    marginBottom: '.4rem',
    padding: '0 .75rem',
    border: '1px solid #FDA29B',
    borderRadius: '999px',
    color: '#B42318',
    background: '#FFFBFA',
    fontFamily: 'inherit',
    fontSize: '.8125rem',
    fontWeight: 700,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#FEF3F2',
    },
    [theme.breakpoints.down('xs')]: {
      order: 0,
      height: '2.25rem',
      marginBottom: 0,
    },
  },
  attentionFilterOn: {
    color: '#FFFFFF',
    borderColor: '#B42318',
    background: '#B42318',
    '&:hover': {
      backgroundColor: '#B42318',
    },
    '& $attentionCount': {
      color: '#B42318',
      background: '#FFFFFF',
    },
  },
  attentionIcon: {
    fontSize: '1rem',
  },
  attentionCount: {
    display: 'inline-flex',
    minWidth: '1.125rem',
    height: '1.125rem',
    padding: '0 .25rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '999px',
    color: '#FFFFFF',
    background: '#B42318',
    fontSize: '.6875rem',
    lineHeight: 1,
  },
  attentionClear: {
    display: 'inline-flex',
    order: 1,
    height: '2rem',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '.35rem',
    marginBottom: '.4rem',
    padding: '0 .75rem',
    borderRadius: '999px',
    color: '#05603A',
    background: '#F6FEF9',
    fontSize: '.8125rem',
    fontWeight: 700,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      order: 0,
      height: '2.25rem',
      marginBottom: 0,
    },
  },

  body: {
    display: 'flex',
    minHeight: 0,
    flex: '1 1 auto',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      overflowY: 'auto',
      overscrollBehavior: 'contain',
    },
  },
  tableHead: {
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    alignItems: 'center',
    gap: '1rem',
    marginTop: '1rem',
    padding: '0 calc(.75rem + 1px) .5rem',
    color: '#475467',
    fontSize: '.6875rem',
    fontWeight: 700,
    letterSpacing: '.08em',
    textTransform: 'uppercase',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  alignRight: {
    textAlign: 'right',
  },
  routeList: {
    display: 'flex',
    minHeight: 0,
    flex: '1 1 auto',
    flexDirection: 'column',
    gap: '.25rem',
    overflowX: 'hidden',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    '&::-webkit-scrollbar': {
      width: '.35rem',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '1rem',
      background: '#D0D5DD',
    },
    [theme.breakpoints.down('xs')]: {
      flex: '0 0 auto',
      gap: '.5rem',
      padding: '0 1rem',
      overflow: 'visible',
    },
  },

  routeItem: {
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    alignItems: 'center',
    gap: '0 1rem',
    padding: '.75rem',
    border: '1px solid transparent',
    borderTopColor: '#EAECF0',
    borderRadius: '12px',
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'minmax(0, 1fr) auto',
      gridTemplateAreas: '"identity status" "capacity status" "details details"',
      alignItems: 'flex-start',
      gap: '0 .75rem',
      padding: '.875rem',
      borderColor: '#EAECF0',
      background: '#FFFFFF',
    },
  },
  routeItemAttention: {
    borderColor: '#FDD9D6',
    background: '#FFFBFA',
    '& + &': {
      marginTop: '.25rem',
    },
    [theme.breakpoints.down('xs')]: {
      borderColor: '#FDD9D6',
      '& + &': {
        marginTop: 0,
      },
    },
  },
  routeItemExpandable: {
    cursor: 'pointer',
  },

  routeIdentity: {
    display: 'flex',
    minWidth: 0,
    alignItems: 'center',
    gap: '.5rem',
    borderRadius: '6px',
    outline: 'none',
    '&:focus-visible': {
      outline: '2px solid #416D0B',
      outlineOffset: '2px',
    },
    [theme.breakpoints.down('xs')]: {
      gridArea: 'identity',
    },
  },
  chevron: {
    flex: '0 0 auto',
    color: '#667085',
    fontSize: '1.125rem',
  },
  chevronAttention: {
    color: '#B42318',
  },
  chevronHidden: {
    visibility: 'hidden',
  },
  colorDot: {
    display: 'inline-block',
    width: '.5rem',
    height: '.5rem',
    flex: '0 0 auto',
    borderRadius: '50%',
  },
  routeNumber: {
    fontSize: '.9375rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  routeNumberAttention: {
    fontWeight: 700,
  },
  routeContext: {
    overflow: 'hidden',
    color: '#475467',
    fontSize: '.875rem',
    fontWeight: 600,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  capacityValue: {
    fontFamily: 'inherit',
    fontSize: '.9375rem',
    '& strong': {
      fontWeight: 700,
    },
    '& > span': {
      color: '#667085',
    },
    [theme.breakpoints.down('xs')]: {
      gridArea: 'capacity',
      marginTop: '.1rem',
      marginLeft: '2.625rem',
      color: '#667085',
      fontSize: '.8125rem',
      '& strong': {
        color: '#1D2939',
      },
    },
  },
  reduceValue: {
    color: '#667085',
    fontFamily: 'inherit',
    fontSize: '.9375rem',
    textAlign: 'right',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  reduceValueDanger: {
    color: '#B42318',
    fontWeight: 700,
  },
  statusCell: {
    textAlign: 'right',
    [theme.breakpoints.down('xs')]: {
      gridArea: 'status',
    },
  },
  status: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '.25rem',
    height: '1.5rem',
    padding: '0 .625rem',
    borderRadius: '999px',
    fontSize: '.75rem',
    fontWeight: 700,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      padding: '0 .5rem',
    },
  },
  statusIcon: {
    fontSize: '.875rem',
  },
  statusDanger: {
    color: '#B42318',
    background: '#FEE4E2',
  },
  statusSuccess: {
    color: '#027A48',
    background: '#D1FADF',
  },
  statusNeutral: {
    color: '#475467',
    background: '#F2F4F7',
  },

  details: {
    gridColumn: '1 / -1',
    marginTop: '.625rem',
    paddingTop: '.625rem',
    borderTop: '1px solid #F2F4F7',
    [theme.breakpoints.down('xs')]: {
      gridArea: 'details',
      marginTop: '.75rem',
      paddingTop: '.75rem',
    },
  },
  detailsAttention: {
    borderTopColor: '#FDD9D6',
  },
  detailsLabel: {
    color: '#667085',
    fontFamily: 'inherit',
    fontSize: '.6875rem',
    fontWeight: 700,
    letterSpacing: '.08em',
    textTransform: 'uppercase',
  },
  detailsTitle: {
    marginTop: '.25rem',
    color: '#1D2939',
    fontFamily: 'inherit',
    fontSize: '.9375rem',
    fontWeight: 600,
    lineHeight: 1.5,
    [theme.breakpoints.down('xs')]: {
      fontSize: '.875rem',
    },
  },
  detailsText: {
    marginTop: '.1rem',
    color: '#667085',
    fontFamily: 'inherit',
    fontSize: '.875rem',
    lineHeight: 1.55,
    [theme.breakpoints.down('xs')]: {
      fontSize: '.8125rem',
    },
  },
  detailsResolution: {
    marginTop: '.5rem',
    color: '#027A48',
    fontFamily: 'inherit',
    fontSize: '.875rem',
    fontWeight: 600,
    lineHeight: 1.5,
    [theme.breakpoints.down('xs')]: {
      fontSize: '.8125rem',
    },
  },
  detailsLoading: {
    display: 'flex',
    marginTop: '.25rem',
    alignItems: 'center',
    gap: '.5rem',
    color: '#667085',
    fontSize: '.875rem',
  },
  detailsError: {
    marginTop: '.25rem',
    color: '#B42318',
    fontFamily: 'inherit',
    fontSize: '.875rem',
    lineHeight: 1.5,
  },

  footer: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    marginTop: '1rem',
    paddingTop: '.875rem',
    borderTop: '1px solid #F2F4F7',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
      gap: '.5rem',
      margin: 0,
      padding: '.75rem 1rem 1rem',
      border: 0,
    },
  },
  footerNote: {
    maxWidth: '30rem',
    color: '#667085',
    fontFamily: 'inherit',
    fontSize: '.8125rem',
    lineHeight: 1.5,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'none',
      fontSize: '.75rem',
    },
  },
  historyButton: {
    display: 'inline-flex',
    height: '2.25rem',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '.35rem',
    padding: '0 .875rem',
    border: '1px solid #C9D0D6',
    borderRadius: '8px',
    color: '#416D0B',
    background: '#FFFFFF',
    fontFamily: 'inherit',
    fontSize: '.875rem',
    fontWeight: 700,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
    [theme.breakpoints.down('xs')]: {
      height: '2.75rem',
      borderRadius: '10px',
    },
  },
  historyIcon: {
    fontSize: '1.125rem',
  },

  emptyState: {
    display: 'flex',
    minHeight: '10rem',
    padding: '2rem',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
  emptyTitle: {
    color: '#344054',
    fontFamily: 'inherit',
    fontSize: '1rem',
    fontWeight: 700,
  },
  emptyDescription: {
    marginTop: '.25rem',
    color: '#667085',
    fontFamily: 'inherit',
    fontSize: '.875rem',
  },
}))
